module.exports = __webpack_public_path__ + "static/img/background.25f29be9.png";